import script from "./MegaMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaMenu.vue?vue&type=script&setup=true&lang=js"

import "./MegaMenu.vue?vue&type=style&index=0&id=686309f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686309f8"]])

export default __exports__